import { h } from 'preact';
import makeTable from '../makeTable.jsx';
import { LazyRpmIssueRecord } from '../RpmIssueRecord/LazyRpmIssueRecord.jsx';

export const UrlTable = makeTable([
  ['URL', 60],
  ['Outbound', 10],
  ['Impressions', 10],
  ['Bad UX %', 10],
  ['Failed metrics', 10],
]);

function renderLazyItem(_item, index) {
  return h(LazyRpmIssueRecord, { key: index });
}

export const lazyList = Array(5).fill(null).map(renderLazyItem);
